import { render, staticRenderFns } from "./OnlineEventIcon.vue?vue&type=template&id=8cc7ca5a"
import script from "./OnlineEventIcon.vue?vue&type=script&lang=ts"
export * from "./OnlineEventIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports